/**
 * @description Change the bill smoother status
 */
export const changeBillSmootherStatus = (
  enrolled: boolean = false,
  active: boolean = false,
): string => {
  return enrolled ? (active ? "Pause?" : "Resume?") : "";
};
